import { t } from "i18next";

import { MileageUnit, PreviousAuctionNoteDTO } from "@/src/types/types";
import { addThousandsSeparator } from "@/src/utils/numberUtils";

export const groupHistoryByAuction = (
  history?: PreviousAuctionNoteDTO[]
): PreviousAuctionNoteDTO[][] => {
  if (!history) return [];

  const groups = new Map<number, PreviousAuctionNoteDTO[]>();
  history.forEach((note) => {
    const group = groups.get(note.auctionId) ?? [];
    group.push(note);
    groups.set(note.auctionId, group);
  });

  return Array.from(groups.values());
};

export const mileageDeltaText = (
  mileageDelta?: number | null,
  mileageUnit?: MileageUnit
): string | undefined => {
  if (mileageDelta === undefined || mileageDelta === null) {
    return undefined;
  }
  const sign = mileageDelta > 0 ? "+" : mileageDelta < 0 ? "-" : "";
  const unit = t(
    `dealer.auctionDetailsPage.mileageUnit.${mileageUnit ?? MileageUnit.KM}`
  );
  return `${sign}${addThousandsSeparator(Math.abs(mileageDelta))} ${unit}`;
};
